import React, { ChangeEvent } from "react";
import { Box } from "@material-ui/core";

interface IProps {
  formState: any,
  onNext: (step: string) => any,
  handleFormChange: (e: ChangeEvent<HTMLInputElement>) => any,
}

const CartPayments: React.FC<IProps> = () => {

  return (
    <Box m={3} justifyContent="center" >
    </Box>
  )
};

export default (CartPayments);
